import { useEffect, useRef, useState } from "react";

const STATS = [
  { value: 15, suffix: "+", label: "Years Experience" },
  { value: 2000, suffix: "+", label: "Roofs Completed" },
  { value: null, label: "Licensed & Insured" },
  { value: 5, suffix: "★", label: "Star Rated" },
];

function Counter({ to, suffix = "", trigger }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!trigger || to == null) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const animate = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(to * eased));
      if (p < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [trigger, to]);
  if (to == null) return null;
  return (
    <span className="tabular-nums">
      {n.toLocaleString()}
      {suffix}
    </span>
  );
}

export default function TrustBar() {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      data-testid="trust-bar"
      className="relative shingle-texture bg-[#0e0e0e] border-y border-white/10 py-8"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 md:gap-y-0 items-center">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`trust-stat-${i}`}
              className="relative flex items-center justify-center md:justify-start gap-4"
            >
              <div className="flex flex-col items-center md:items-start">
                {s.value != null ? (
                  <span className="font-display font-extrabold text-3xl md:text-4xl text-white leading-none">
                    <Counter to={s.value} suffix={s.suffix} trigger={seen} />
                  </span>
                ) : (
                  <span className="font-display font-extrabold text-xl md:text-2xl text-[var(--crest-amber)] leading-none uppercase tracking-wide">
                    Licensed
                  </span>
                )}
                <span className="mt-2 font-body text-[11px] md:text-xs uppercase tracking-[0.25em] text-white/55">
                  {s.label}
                </span>
              </div>
              {i < STATS.length - 1 && (
                <div className="hidden md:block amber-divider ml-auto" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
